import React from 'react';
import useStyle from './Objective.style';
import { IconButton } from 'components/atoms/Buttons/IconButton';
import { calculateProgress } from 'helpers/class/objective/calculateProgress';

interface ObjectiveProps {
  nameObjective?: string | null;
  caObjective?: number | null;
  currentCa?: number | null;
  isProf: boolean;
  setShowObjective: (show: boolean) => void;
}

const Objective = ({
  nameObjective,
  caObjective,
  currentCa,
  isProf,
  setShowObjective
}: ObjectiveProps) => {
  const { objective, color } = calculateProgress(currentCa, caObjective);
  const classes = useStyle({
    objective,
    color
  });
  return (
    <div className={classes.root}>
      <div className={classes.objectif}>
        <div className={classes.progressContent}>
          <p className={classes.ca}>
            Obtenez un CA de classe de {caObjective}€
          </p>
          <p className={classes.progress}>
            {objective === 100 ? 'Terminé' : `En cours : ${objective}%`}
          </p>
          <div className={classes.progressBar}></div>
        </div>
        <div className={classes.title}>
          <p>
            <span role="img" aria-label="gift">
              🎁
            </span>{' '}
            {nameObjective}
          </p>
        </div>
      </div>
      {isProf && (
        <div className={classes.actions}>
          <IconButton
            icon={'Edit'}
            variant={'backless'}
            color="white"
            onClick={() => setShowObjective(false)}
          />
        </div>
      )}
    </div>
  );
};

export default Objective;
